import { GenericObject } from 'core/models/platform';
import { OutputAbs, OutputExt } from '../models/store';
import {
  TransformedSummarizationResult,
  TransformedSummarizationResultInAbs,
} from '../models/transformation';

const passTypeCheckForObjs = (obj: unknown) => obj != null && typeof obj === 'object';

export function ExtUnionGuard(
  extObject:
    | OutputAbs
    | string
    | OutputExt
    | number
    | boolean
    | GenericObject
    | null
    | string[]
    | undefined
): extObject is OutputExt {
  if (passTypeCheckForObjs(extObject)) {
    return !!Object.getOwnPropertyDescriptor(extObject, 'sentenceSequence');
  }
  return false;
}

export function AbsUnionGuard(
  absObject:
    | OutputAbs
    | string
    | OutputExt
    | number
    | boolean
    | GenericObject
    | null
    | string[]
    | undefined
): absObject is OutputAbs {
  if (passTypeCheckForObjs(absObject)) {
    return !!Object.getOwnPropertyDescriptor(absObject, 'summaryPara');
  }
  return false;
}

export function TransportSummarizationExtUnionGuard(
  extObject: TransformedSummarizationResult | TransformedSummarizationResultInAbs
): extObject is TransformedSummarizationResult {
  if (passTypeCheckForObjs(extObject)) {
    return !!Object.getOwnPropertyDescriptor(extObject, 'sentences');
  }
  return false;
}

export function TransportSummarizationAbsUnionGuard(
  absObject: TransformedSummarizationResult | TransformedSummarizationResultInAbs
): absObject is TransformedSummarizationResultInAbs {
  if (passTypeCheckForObjs(absObject)) {
    return !!Object.getOwnPropertyDescriptor(absObject, 'summaryPara');
  }
  return false;
}
